import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { MapService } from 'src/app/Service/map.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import * as moment from 'moment-jalaali';
import * as XLSX from 'xlsx';
import axios from 'src/app/Service/axios';
declare let $: any;

@Component({

  selector: 'app-entry-exit-madonik',

  templateUrl: './entry-exit-madonik.component.html',

  styleUrls: ['./entry-exit-madonik.component.css']

})

export class EntryExitMadonikComponent implements OnInit {

  lst_Request = [];

  lst_Search = [];

  lst_Passenger = [];

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strSDate: new FormControl(moment().subtract(1, 'day').format('jYYYY/jMM/jDD')),

    strEDate: new FormControl(moment().add(0, 'day').format('jYYYY/jMM/jDD')),

    iPassenger: new FormControl('-1'),

  })

  mdl_Absence: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iPresenceAbsence: new FormControl('', Validators.required),

    strTime: new FormControl('', Validators.required),

    strETime: new FormControl('', Validators.required),

    strComment: new FormControl('', Validators.required),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private mapService: MapService

  ) { }

  ngOnInit(): void {

    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });

    this.getPassenger()

  }

  async getPassenger() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`School_Passenger_ListAll`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Passenger = res;

  }

  async search_Trip() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`PresenceAbsence_Search`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Request = res;

    this.lst_Search = res;

  }

  filter_list(val: any) {

    // this.lst_Trips = this.lst_Search.filter((el: any) => {

    //   return el?.strSystemUser_FullName?.includes(val.value) ||

    //     el.iEmdadRo?.toString().includes(val.value) ||

    //     el.strTaxiLon_TripStatus_strComment?.toString().includes(val.value) ||

    //     el.strSCityName?.includes(val.value) ||

    //     el.strFullName?.includes(val.value) ||

    //     el.strMobile?.includes(val.value) ||

    //     el.strDriver_Mobile?.includes(val.value) ||

    //     el.strDriver_FullName?.includes(val.value)

    // });

    // if (val.value.trim() == '') {

    //   this.lst_Trips = this.lst_Search;

    // }

  }

  openEdit(item) {

    this.mdl_Absence.patchValue({

      iPresenceAbsence: item.iPresenceAbsence,

      strTime: item.strTime,

      strETime: item.strETime,

      strComment: item.strComment,

    })

    $("#entryExit_Modal").modal('show');

  }

  editEntry() {

    if (this.mdl_Absence.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید');

    this.mdl_Absence.get('strTime')?.setValue($("#strTime").val());

    this.mdl_Absence.get('strETime')?.setValue($("#strETime").val());

    $.confirm({

      title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "ویرایش",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner();

            let res = JSON.parse((await axios.post(`PresenceAbsence_Edit`, this._otherService.stringNumberToNumber(this.mdl_Absence.value))).data.toString());

            this._otherService.nonespinner();

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            this.search_Trip()

            this._tooltip.showSuccess('با موفقیت ویرایش شد');

            $("#entryExit_Modal").modal('hide');

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  exportExcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'گزارش ورود و خروج.xlsx');
  }

}
